import { render, staticRenderFns } from "./Spiner.vue?vue&type=template&id=e61695a6"
var script = {}
import style0 from "./Spiner.vue?vue&type=style&index=0&id=e61695a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports